import * as React from "react";
import { Component } from "react";
import { Pager } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import LoadingStatus from "src/components/common/LoadingStatus";
import { IServiceCharge } from "src/components/projects/project/statements/advanced/interfaces";
import AdvancedSingleRateStatement from "src/components/projects/project/statements/advanced/singlerate/AdvancedSingleRateStatement";
import StatementNavbar from "src/components/projects/project/statements/StatementNavbar";
import { IPdfPage, round, TIMEOUT } from "src/global";
import fs from "src/services/config/fbConfig";
import {
  IAdvancedSingleRateStatementPageProps,
  IAdvancedSingleRateStatementPageState,
} from "./interfaces";

export default class AdvancedSingleRateStatementPage extends Component<
  IAdvancedSingleRateStatementPageProps,
  IAdvancedSingleRateStatementPageState
> {
  private projectDocument: firebase.firestore.DocumentReference;
  private statementDocument: firebase.firestore.DocumentReference;
  private priorStatementDocument: firebase.firestore.DocumentReference | null;
  private simpleStatementDocument: firebase.firestore.DocumentReference;
  private advancedStatementDocument: firebase.firestore.DocumentReference;
  private priorAdvancedStatementDocument: firebase.firestore.DocumentReference | null;
  private serviceChargesCollection: firebase.firestore.CollectionReference;
  private unsubscribeServiceCharges: any;
  public constructor(props: IAdvancedSingleRateStatementPageProps) {
    super(props);

    this.state = {
      loading: true,
      needsSaving: false,
      serviceStartDate: Date.now(),
      serviceEndDate: Date.now(),
      statementDate: Date.now(),
      yearsWithSolar: 0,
      totalAmountDue: 0,
      gridReadDate: Date.now(),
      gridReading: 0,
      priorGridReadDate: Date.now(),
      priorGridReading: 0,
      solarReadDate: Date.now(),
      solarReading: 0,
      priorSolarReadDate: Date.now(),
      priorSolarReading: 0,
      solarGenerated: 0,
      credits: 0,
      serviceCharges: [],
      allowStatementParsing: false,
      allowStatementUpload: false,
      file: null,
      filename: "",
      storagePath: "",
      uploaded: false,
      priorDataEditable: false,
      priorId: undefined,
      nextId: undefined,
    };

    this.renderStatementNavbar = this.renderStatementNavbar.bind(this);

    this.handleServiceStartDateChanged = this.handleServiceStartDateChanged.bind(this);
    this.handleServiceEndDateChanged = this.handleServiceEndDateChanged.bind(this);

    this.handleStatementDateChanged = this.handleStatementDateChanged.bind(this);
    this.handleYearsWithSolarChanged = this.handleYearsWithSolarChanged.bind(this);
    this.handleTotalAmountDueChanged = this.handleTotalAmountDueChanged.bind(this);

    this.handleGridReadDateChanged = this.handleGridReadDateChanged.bind(this);
    this.handleGridReadingChanged = this.handleGridReadingChanged.bind(this);
    this.handlePriorGridReadDateChanged = this.handlePriorGridReadDateChanged.bind(this);
    this.handlePriorGridReadingChanged = this.handlePriorGridReadingChanged.bind(this);

    this.handleSolarReadDateChanged = this.handleSolarReadDateChanged.bind(this);
    this.handleSolarReadingChanged = this.handleSolarReadingChanged.bind(this);
    this.handlePriorSolarReadDateChanged = this.handlePriorSolarReadDateChanged.bind(this);
    this.handlePriorSolarReadingChanged = this.handlePriorSolarReadingChanged.bind(this);

    this.handleSolarGeneratedChanged = this.handleSolarGeneratedChanged.bind(this);

    this.updateServiceCharges = this.updateServiceCharges.bind(this);

    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.addServiceCharge = this.addServiceCharge.bind(this);
    this.deleteServiceCharge = this.deleteServiceCharge.bind(this);
    this.updateServiceCharge = this.updateServiceCharge.bind(this);
    this.copyPriorServiceCharges = this.copyPriorServiceCharges.bind(this);
    this.calculateTotalAmountDue = this.calculateTotalAmountDue.bind(this);
    this.sumServiceCharges = this.sumServiceCharges.bind(this);

    this.handleFilenameChanged = this.handleFilenameChanged.bind(this);
    this.deleteUploadedStatement = this.deleteUploadedStatement.bind(this);
    this.setStoragePath = this.setStoragePath.bind(this);
    this.setUploadStatus = this.setUploadStatus.bind(this);

    this.saveData = this.saveData.bind(this);
  }

  public componentWillMount() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.projectDocument = fs.fs.collection("projects").doc(projectId);
    this.statementDocument = this.projectDocument
      .collection("statements")
      .doc(this.props.match.params.id);
    this.advancedStatementDocument = this.projectDocument
      .collection("advancedSingleRateStatements")
      .doc(this.statementDocument.id);
    this.simpleStatementDocument = this.projectDocument
      .collection("simpleSingleRateStatements")
      .doc(this.statementDocument.id);
    this.serviceChargesCollection = this.advancedStatementDocument.collection("serviceCharges");
    this.unsubscribeServiceCharges = this.serviceChargesCollection
      .orderBy("timestamp")
      .onSnapshot(this.updateServiceCharges);
    if (this.props.match.params.priorId !== undefined) {
      this.priorStatementDocument = this.projectDocument
        .collection("statements")
        .doc(this.props.match.params.priorId);
      this.priorAdvancedStatementDocument = this.projectDocument
        .collection("advancedSingleRateStatements")
        .doc(this.priorStatementDocument.id);
    } else {
      this.priorStatementDocument = null;
      this.priorAdvancedStatementDocument = null;
    }
  }

  public componentDidMount() {
    let useNextId: boolean = false;
    let lastId: string | undefined;
    this.projectDocument
      .collection("statements")
      .orderBy("statementDate")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            if (useNextId) {
              useNextId = false;
              this.setState({ nextId: doc.id });
            }
            if (doc.id === this.props.match.params.id) {
              useNextId = true;
            }
            if (doc.id === this.props.match.params.priorId) {
              this.setState({ priorId: lastId });
            }
            lastId = doc.id;
          }
        });
      })
      .then(() => {
        this.projectDocument
          .get()
          .then(doc => {
            if (doc.exists) {
              const {
                allowStatementParsing,
                allowStatementUpload,
                priorDataEditable,
              } = doc.data() as any;
              this.setState({
                allowStatementParsing: allowStatementParsing ? allowStatementParsing : false,
                allowStatementUpload: allowStatementUpload ? allowStatementUpload : false,
                priorDataEditable: priorDataEditable ? priorDataEditable : false,
              });
            }
          })
          .then(() => {
            this.statementDocument
              .get()
              .then(doc => {
                if (doc.exists) {
                  const {
                    serviceStartDate,
                    serviceEndDate,
                    statementDate,
                    yearsWithSolar,
                    totalAmountDue,
                    storagePath,
                    filename,
                    uploaded,
                  } = doc.data() as any;
                  this.setState({
                    serviceStartDate: serviceStartDate ? serviceStartDate : Date.now(),
                    serviceEndDate: serviceEndDate ? serviceEndDate : Date.now(),
                    statementDate: statementDate ? statementDate : Date.now(),
                    yearsWithSolar: yearsWithSolar ? yearsWithSolar : 0,
                    totalAmountDue: totalAmountDue ? totalAmountDue : 0,
                    storagePath: storagePath ? storagePath : "",
                    filename: filename ? filename : "",
                    uploaded: uploaded ? uploaded : false,
                  });

                  if (storagePath && storagePath !== "") {
                    const storedFile = fs.fsStorage.ref().child(storagePath);
                    storedFile
                      .getMetadata()
                      .then(metaData => {
                        const filename = metaData.customMetadata.filename;
                        this.setState({ filename, uploaded: true });
                      })
                      .catch(error => {
                        console.log(error);
                      });
                  }
                }
              })
              .then(() => {
                this.advancedStatementDocument
                  .get()
                  .then(doc => {
                    if (doc.exists) {
                      const {
                        gridReadDate,
                        gridReading,
                        priorGridReadDate,
                        priorGridReading,
                        solarReadDate,
                        solarReading,
                        priorSolarReadDate,
                        priorSolarReading,
                        solarGenerated,
                      } = doc.data() as any;
                      this.setState({
                        gridReadDate: gridReadDate ? gridReadDate : Date.now(),
                        gridReading: gridReading ? gridReading : 0,
                        solarReadDate: solarReadDate ? solarReadDate : 0,
                        solarReading: solarReading ? solarReading : 0,
                        solarGenerated: solarGenerated ? solarGenerated : 0,
                        priorGridReadDate: priorGridReadDate ? priorGridReadDate : Date.now(),
                        priorGridReading: priorGridReading ? priorGridReading : 0,
                        priorSolarReadDate: priorSolarReadDate ? priorSolarReadDate : Date.now(),
                        priorSolarReading: priorSolarReading ? priorSolarReading : 0,
                        credits: 0,
                      });
                    } else {
                      this.advancedStatementDocument.set({
                        gridReadDate: Date.now(),
                        gridReading: 0,
                        solarReadDate: Date.now(),
                        solarReading: 0,
                        solarGenerated: 0,
                        priorGridReadDate: Date.now(),
                        priorGridReading: 0,
                        priorSolarReadDate: Date.now(),
                        priorSolarReading: 0,
                        creditBalance: 0,
                      });
                    }
                  })
                  .then(() => {
                    if (this.priorAdvancedStatementDocument) {
                      this.priorAdvancedStatementDocument
                        .get()
                        .then(doc => {
                          if (doc.exists) {
                            const {
                              gridReadDate,
                              gridReading,
                              solarReadDate,
                              solarReading,
                              creditBalance,
                            } = doc.data() as any;
                            this.setState({
                              priorGridReadDate: gridReadDate ? gridReadDate : Date.now(),
                              priorGridReading: gridReading ? gridReading : 0,
                              priorSolarReadDate: solarReadDate ? solarReadDate : Date.now(),
                              priorSolarReading: solarReading ? solarReading : 0,
                              credits: creditBalance ? creditBalance : 0,
                            });
                          }
                        })
                        .then(() => {
                          if (this.priorStatementDocument) {
                            this.priorStatementDocument.get().then(doc => {
                              if (doc.exists) {
                                const { serviceEndDate } = doc.data() as any;
                                this.setState({
                                  serviceStartDate: serviceEndDate ? serviceEndDate : Date.now(),
                                  priorGridReadDate: serviceEndDate ? serviceEndDate : Date.now(),
                                  priorSolarReadDate: serviceEndDate ? serviceEndDate : Date.now(),
                                });
                              }
                            });
                          }
                        });
                    }
                  });
              })
              .then(() => {
                /*Recalculate the total amount due to make sure it is in sync with the data.*/
                const totalAmountDue = this.calculateTotalAmountDue();
                this.setState({ loading: false, needsSaving: false, totalAmountDue });
              });
          });
      });
  }

  public componentWillUnmount() {
    this.unsubscribeServiceCharges(this.updateServiceCharges);
  }

  public render() {
    if (!this.props.appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.loading) {
      return <LoadingStatus text="Loading..." />;
    }

    const serviceCharges: IServiceCharge[] = this.state.serviceCharges;

    let priorStatementPath: string = "#";
    let nextStatementPath: string = "#";

    if (this.props.match.params.priorId && this.state.priorId) {
      priorStatementPath = `/advancedsingleratestatement/${this.props.match.params.priorId}/${
        this.state.priorId
      }`;
    } else if (this.props.match.params.priorId && !this.state.priorId) {
      priorStatementPath = `/advancedsingleratestatement/${this.props.match.params.priorId}`;
    }

    if (this.props.match.params.id && this.state.nextId) {
      nextStatementPath = `/advancedsingleratestatement/${this.state.nextId}/${
        this.props.match.params.id
      }`;
    }

    return (
      <div className="container-fixed-navbar">
        {this.renderStatementNavbar()}
        <div className="container">
          <Pager>
            <Pager.Item
              previous={true}
              href={priorStatementPath}
              disabled={!this.props.match.params.priorId}
              // onClick={this.navigateToPreviousStatement}
            >
              &larr; Previous Statement
            </Pager.Item>
            <Pager.Item
              next={true}
              href={nextStatementPath}
              disabled={!this.state.nextId}
              // onClick={this.navigateToNextStatement}
            >
              Next Statement &rarr;
            </Pager.Item>
          </Pager>
        </div>
        <AdvancedSingleRateStatement
          history={this.props.history}
          match={this.props.match}
          appService={this.props.appService}
          serviceStartDate={this.state.serviceStartDate}
          serviceEndDate={this.state.serviceEndDate}
          serviceStartDateChanged={this.handleServiceStartDateChanged}
          serviceEndDateChanged={this.handleServiceEndDateChanged}
          statementDate={this.state.statementDate}
          yearsWithSolar={this.state.yearsWithSolar}
          totalAmountDue={this.state.totalAmountDue}
          statementDateChanged={this.handleStatementDateChanged}
          yearsWithSolarChanged={this.handleYearsWithSolarChanged}
          totalAmountDueChanged={this.handleTotalAmountDueChanged}
          gridReadDate={this.state.gridReadDate}
          gridReading={this.state.gridReading}
          gridReadDateChanged={this.handleGridReadDateChanged}
          gridReadingChanged={this.handleGridReadingChanged}
          priorGridReadDate={this.state.priorGridReadDate}
          priorGridReading={this.state.priorGridReading}
          solarReadDate={this.state.solarReadDate}
          solarReading={this.state.solarReading}
          solarReadDateChanged={this.handleSolarReadDateChanged}
          solarReadingChanged={this.handleSolarReadingChanged}
          priorSolarReadDate={this.state.priorSolarReadDate}
          priorSolarReading={this.state.priorSolarReading}
          solarGenerated={this.state.solarGenerated}
          solarGeneratedChanged={this.handleSolarGeneratedChanged}
          priorGridReadDateChanged={this.handlePriorGridReadDateChanged}
          priorGridReadingChanged={this.handlePriorGridReadingChanged}
          priorSolarReadDateChanged={this.handlePriorSolarReadDateChanged}
          priorSolarReadingChanged={this.handlePriorSolarReadingChanged}
          credits={this.state.credits}
          serviceCharges={serviceCharges}
          addServiceCharge={this.addServiceCharge}
          deleteServiceCharge={this.deleteServiceCharge}
          updateServiceCharge={this.updateServiceCharge}
          copyPriorServiceCharges={this.copyPriorServiceCharges}
          needsSaving={this.state.needsSaving}
          priorDataEditable={this.state.priorDataEditable}
        />
      </div>
    );
  }

  private renderStatementNavbar() {
    const brand = this.props.appService.getActiveProjectLocation();
    return (
      <StatementNavbar
        appService={this.props.appService}
        match={this.props.match}
        history={this.props.history}
        isAdvanced={true}
        allowStatementParsing={this.state.allowStatementParsing}
        allowStatementUpload={this.state.allowStatementUpload}
        brand={brand}
        file={this.state.file}
        filename={this.state.filename}
        handleFilenameChanged={this.handleFilenameChanged}
        importPDFData={this.importPDFData}
        setStoragePath={this.setStoragePath}
        needsSaving={this.state.needsSaving}
        storagePath={this.state.storagePath}
        saveData={this.saveData}
        deleteUploadedStatement={this.deleteUploadedStatement}
        uploaded={this.state.uploaded}
        setUploadStatus={this.setUploadStatus}
        priorDataEditable={this.state.priorDataEditable}
      />
    );
  }

  private handleSave(e: any) {
    e.preventDefault();
    this.saveData(this.state.needsSaving);
  }
  private saveData(needsSaving: boolean) {
    if (needsSaving) {
      this.setState({ loading: true });
      const solarReceived: number = this.state.solarReading - this.state.priorSolarReading;
      const gridUsage: number = this.state.gridReading - this.state.priorGridReading;
      let creditBalance: number = solarReceived + this.state.credits - gridUsage;
      if (creditBalance < 0) {
        creditBalance = 0;
      }
      this.statementDocument
        .update({
          serviceStartDate: this.state.serviceStartDate,
          serviceEndDate: this.state.serviceEndDate,
          statementDate: this.state.statementDate,
          yearsWithSolar: this.state.yearsWithSolar,
          totalAmountDue: this.state.totalAmountDue,
          storagePath: this.state.storagePath,
          filename: this.state.filename,
          uploaded: this.state.uploaded,
        })
        .then(() => {
          this.advancedStatementDocument.update({
            gridReadDate: this.state.gridReadDate,
            gridReading: this.state.gridReading,
            solarReadDate: this.state.solarReadDate,
            solarReading: this.state.solarReading,
            priorGridReadDate: this.state.priorGridReadDate,
            priorGridReading: this.state.priorGridReading,
            priorSolarReadDate: this.state.priorSolarReadDate,
            priorSolarReading: this.state.priorSolarReading,
            solarGenerated: this.state.solarGenerated,
            creditBalance,
          });
        })
        .then(() => {
          this.simpleStatementDocument.update({
            gridUsage,
            solarUsage: solarReceived,
            solarGenerated: Number(this.state.solarGenerated),
            lastMonthCredit: creditBalance,
          });
        })
        .then(() => {
          this.setState({ loading: false, needsSaving: false });
        });
    }
  }

  private handleCancel(e: any) {
    e.preventDefault();
  }

  private handleGridReadDateChanged(e: any) {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      gridReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handleGridReadingChanged(e: any) {
    this.setState({
      gridReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handlePriorGridReadDateChanged(e: any) {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      priorGridReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handlePriorGridReadingChanged(e: any) {
    this.setState({
      priorGridReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }

  private handleSolarReadDateChanged(e: any) {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      solarReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handleSolarReadingChanged(e: any) {
    this.setState({
      solarReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handlePriorSolarReadDateChanged(e: any) {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      priorSolarReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handlePriorSolarReadingChanged(e: any) {
    this.setState({
      priorSolarReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }

  private handleSolarGeneratedChanged(e: any) {
    this.setState({
      solarGenerated: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }

  private updateServiceCharges(querySnapshot: firebase.firestore.QuerySnapshot) {
    const serviceCharges: IServiceCharge[] = [];
    querySnapshot.forEach(doc => {
      const { timestamp, description, value, rate, unit, totalCharge } = doc.data();
      serviceCharges.push({
        id: doc.id,
        timestamp,
        description,
        value,
        rate,
        unit,
        totalCharge,
      });
    });
    const totalAmountDue = this.sumServiceCharges(serviceCharges);
    this.setState({ serviceCharges, loading: false, totalAmountDue });
  }

  private handleStatementDateChanged(e: any) {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      statementDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handleServiceStartDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    const date = new Date(e.currentTarget.value).valueOf();
    this.setState({
      serviceStartDate: date,
      priorGridReadDate: date,
      priorSolarReadDate: date,
      needsSaving: true,
    });
  }
  private handleServiceEndDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    const date = new Date(e.currentTarget.value).valueOf();
    this.setState({
      serviceEndDate: date,
      gridReadDate: date,
      solarReadDate: date,
      needsSaving: true,
    });
  }
  private handleYearsWithSolarChanged(e: any) {
    this.setState({
      yearsWithSolar: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handleTotalAmountDueChanged(e: any) {
    this.setState({
      totalAmountDue: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }

  private addServiceCharge() {
    setTimeout(() => {
      this.serviceChargesCollection.add({
        timestamp: Date.now(),
        description: "",
        value: 0,
        unit: "kWh",
        rate: 0,
        totalCharge: 0,
      });
    }, 250);
    this.setState({ needsSaving: true });
  }
  private deleteServiceCharge(serviceCharge: IServiceCharge) {
    this.serviceChargesCollection.doc(serviceCharge.id).delete();
    this.setState({ needsSaving: true });
  }
  private updateServiceCharge(serviceCharge: IServiceCharge): void {
    serviceCharge.totalCharge = round(serviceCharge.value * serviceCharge.rate, 3);
    this.serviceChargesCollection
      .doc(serviceCharge.id)
      .update({
        description: serviceCharge.description,
        value: serviceCharge.value,
        unit: serviceCharge.unit,
        rate: serviceCharge.rate,
        totalCharge: serviceCharge.totalCharge,
      })
      .then(() => {
        const totalAmountDue = this.calculateTotalAmountDue();
        this.setState({ totalAmountDue, needsSaving: true });
      });
  }
  private calculateTotalAmountDue(): number {
    let totalAmountDue = 0.0;
    this.state.serviceCharges.forEach(serviceCharge => {
      const charge = round(serviceCharge.totalCharge, 2);
      totalAmountDue += charge;
    });
    return totalAmountDue;
  }
  private sumServiceCharges(serviceCharges: IServiceCharge[]): number {
    let totalAmountDue = 0.0;
    serviceCharges.forEach(serviceCharge => {
      const charge = round(serviceCharge.totalCharge, 2);
      totalAmountDue += charge;
    });
    return totalAmountDue;
  }

  private copyPriorServiceCharges() {
    if (this.priorAdvancedStatementDocument) {
      const priorServiceChargesCollection = this.priorAdvancedStatementDocument.collection(
        "serviceCharges"
      );

      let totalAmountDue = 0;
      this.setState({ loading: true });
      priorServiceChargesCollection
        .orderBy("timestamp")
        .get()
        .then(querySnapshot =>
          querySnapshot.forEach(doc => {
            const { timestamp, description, value, unit, rate } = doc.data();
            const totalCharge = round(rate * value, 3);
            totalAmountDue += round(totalCharge, 2);
            this.serviceChargesCollection.add({
              timestamp,
              description,
              value,
              unit,
              rate,
              totalCharge,
            });
          })
        )
        .then(() => {
          this.setState({
            totalAmountDue,
            loading: false,
            needsSaving: true,
          });
        });
    }
  }

  private handleFilenameChanged(e: any) {
    const files: FileList = e.target.files;
    if (files) {
      const file: File = files[0];
      if (file) {
        this.setState({ file, filename: file.name });
      }
    }
  }

  private deleteUploadedStatement() {
    console.log("advancedSingleRateStatementPage");
    setTimeout(() => {
      this.setState({
        file: null,
        filename: "",
        storagePath: "",
        uploaded: false,
      });
    }, TIMEOUT);
    this.saveData(true);
  }

  private importPDFData(pdfPages: IPdfPage[], importType: number): void {
    console.log(pdfPages);
  }

  private setStoragePath(storagePath: string, filename: string): void {
    this.setState({ storagePath, filename });
  }

  private setUploadStatus(uploaded: boolean): void {
    this.setState({ uploaded: true, needsSaving: true });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/statements/advanced/singlerate/AdvancedSingleRateStatementPage.tsx